const icons = {
  arrowUp: 'i-ph-arrow-up',
  arrowDown: 'i-ph-arrow-down',
  arrowLeft: 'i-ph-arrow-left',
  arrowRight: 'i-ph-arrow-right',
  check: 'i-ph-check',
  chevronDoubleLeft: 'i-ph-caret-double-left',
  chevronDoubleRight: 'i-ph-caret-double-right',
  chevronDown: 'i-ph-caret-down',
  chevronLeft: 'i-ph-caret-left',
  chevronRight: 'i-ph-caret-right',
  chevronUp: 'i-ph-caret-up',
  close: 'i-ph-x',
  ellipsis: 'i-ph-dots-three',
  external: 'i-ph-arrow-square-out',
  folder: 'i-ph-folder',
  folderOpen: 'i-ph-folder-notch-open',
  loading: 'i-ph-spinner-gap',
  minus: 'i-ph-minus',
  plus: 'i-ph-plus',
  search: 'i-ph-magnifying-glass',
  user: 'i-ph-user',
  counterClockwise: 'i-ph-clock-counter-clockwise',
  refresh: 'i-ph-arrow-clockwise',
  placeholder: 'i-ph-placeholder',
  info: 'i-ph-info',
  success: 'i-ph-check-circle',
  warning: 'i-ph-warning',
  error: 'i-ph-warning-circle',
  question: 'i-ph-question',
  email: 'i-ph-envelope',
  lock: 'i-ph-lock',
  eye: 'i-ph-eye',
  eyeSlash: 'i-ph-eye-slash',
  phone: 'i-ph-phone',
  calendar: 'i-ph-calendar',
  editPencil: 'i-ph-pencil-simple',
  save: 'i-ph-floppy-disk',
  shoppingCart: 'ph:shopping-cart-simple',
  orders: 'i-ph-shopping-bag',
  confirmationCodeIcon: 'ph:fingerprint-simple',
  suggestion: 'i-ph-lightbulb',
  logOut: 'i-ph-sign-out',
  logIn: 'i-ph-sign-in',
  address: 'i-ph-map-pin',
  circle: 'i-ph-circle',
  trash: 'i-ph-trash',
  support: 'i-ph-lifebuoy',
  globe: 'i-ph-globe',
  filter: 'i-ph-sliders',
  closeCircle: 'i-ph-x-circle',
  note: 'i-ph-note',
  funnel: 'i-ph-funnel',
  pdf: 'ph-file-pdf',
  phonefill: 'i-ph-phone-fill',
}

export default icons
export type iconsTheme = typeof icons
